<template>
  <b-container fluid>
    <b-row style="margin-bottom: 5px;">
      <b-col cols="auto">
        漁業種類別:
      </b-col>
      <b-col v-if="obj.options.length > 0" cols="10">
        <v-select
          style="min-width:fit-content; width: 20vh; display: inline-grid; margin-right: 10px;"
          v-model="obj.value"
          :options="obj.options"
          :selectable="(y) => y.disabled"
        ></v-select>
      </b-col>
      <b-col v-else>
        <b-spinner
          style="width: 1.5rem; height: 1.5rem;"
          variant="success"
          label="Spinning"
        />
      </b-col>
    </b-row>
    <div v-show="obj.chart.ifshow">
      <b-row style="margin-bottom: 5px;">
        <b-col cols="auto">
          面積單位:
        </b-col>
        <b-col v-if="obj.unitoptions.length > 0" cols="10">
          <b-form-select
            style="min-width:fit-content; width: 20vh; display: inline-grid; margin-right: 10px;"
            v-model="obj.unit"
            :options="obj.unitoptions"
          ></b-form-select>
        </b-col>
      </b-row>
      <b-row style="margin-bottom: 5px;">
        <b-col>
          <b-form-checkbox
            id="checkbox2-1"
            v-show="obj.chart.options.yaxis.length > 0"
            v-model="dataLabels"
            :value="true"
            :unchecked-value="false"
            >顯示數值標籤
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          v-if="!obj.chart.ifloading"
          style="width:100%;"
        >
          <apexchart
            style="padding: 10px;"
            ref="chart1ref"
            type="line"
            :options="obj.chart.options"
            :series="obj.chart.series"
          ></apexchart>
        </b-col>
        <b-col v-else>
          <b-spinner
            style="width: 1.5rem; height: 1.5rem;"
            variant="success"
            label="Spinning"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table
            :items="obj.table.items"
            :fields="obj.table.fields"
            :current-page="obj.table.currentPage"
            :per-page="obj.table.perPage"
            :busy="obj.table.isBusy"
            responsive
            striped
            hover
          >
            <template #table-busy>
              <div class="text-center text-success my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(name)="data">
              <b class="text-info">{{ data.value.last.toUpperCase() }}</b
              >, <b>{{ data.value.first }}</b>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            v-model="obj.table.currentPage"
            :total-rows="obj.table.totalRows"
            :per-page="obj.table.perPage"
            small
          ></b-pagination>
        </b-col>
        <b-col cols="auto">
          <span>共 {{ obj.table.totalRows }}筆資料</span>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          資料來源:漁業署
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      dataLabels:true,
      obj: {
        options: [],
        value: { label: "請選擇", code: "請選擇", disabled: false },
        items: [],
        unit: null,
        unitoptions: [],
        list: {
          timelist: [],
          mixlist: [],
          sinlist: [],
          reslist: [],
        },
        chart: {
          ifshow: false,
          ifloading: true,
          series: [],
          options: {
            chart: {
              height: 300,
              type: "line",
              zoom: {
                enabled: false,
              },
            },
            dataLabels: {
              enabled: true,
            },
            noData: {
              text: "目前無資料",
              align: "center",
              verticalAlign: "middle",
            },
            labels: [],
            yaxis: [],
            xaxis: {
              type: "datetime",
              labels: {
                formatter: function(value, timestamp) {
                  var date = new Date(timestamp);
                  if (date.getFullYear() < 1975) return;
                  var year = date.getFullYear() - 1911;
                  return (
                    year + "/" + (date.getMonth() + 1) + "/" + date.getDate()
                  ); // The formatter function overrides format property
                },
              },
            },
            colors: [
              "#008FFB",
              "#19535f",
              "#FEB019",
              "#FF4560",
              "#775DD0",
              "#1c22ce",
              "#ff7b3d",
              "#f9b5c0",
              "#4c1a11",
            ],
            plotOptions: {
              bar: {
                columnWidth: "20%",
              },
            },
          },
        },
        table: {
          fields: [
            {
              key: "SIF_UNIT",
              label: "面積單位",
            },
            {
              key: "SIF_SPEC",
              label: "魚類分類",
            },
            {
              key: "SIF_DATE",
              label: "資料年月",
            },
            {
              key: "SIF_SIN",
              label: "單養",
            },
            {
              key: "SIF_MIX",
              label: "混養",
            },
            // {
            //   key: "SIF_RES",
            //   label: "休養",
            // },
          ],
          items: [],
          allitems: [],
          list1: [],
          list2: [],
          totalRows: 0,
          currentPage: 1,
          perPage: 10,
          isBusy: true,
          pageoptions: [10, 50, 100],
        },
        window: {
          width: 0,
        },
      },
      apiGetFishSpecList: (data) =>
        this.userRequest.post("/API/Default/getFishSpecList", data),
      apiGetFishStatisList: (data) =>
        this.userRequest.post("/API/Default/getFishStatisList", data),
    };
  },
  created() {
    // window.addEventListener("resize", this.handleResize);
    // this.handleResize();
    this.init();
  },
  // destroyed() {
  //   window.removeEventListener("resize", this.handleResize);
  // },
  computed: {
    ifstacked() {
      return this.obj.window.width <= 750;
    },
  },
  methods: {
    init() {
      this.FunctionToken(this.getFishSpecList, {});
    },
    getFishSpecList(data) {
      this.apiGetFishSpecList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.obj.options = [];
            let arr = JSON.parse(json.Data);
            arr.forEach((x) => {
              let obj = {
                label: x.SIF_SPEC.split(" ")[1],
                code: x.SIF_SPEC,
                disabled: true,
              };
              this.obj.options.push(obj);
            });
            this.obj.options.unshift({
              label: "請選擇",
              code: "請選擇",
              disabled: false,
            });
          }
        })
        .catch((err) => console.warn(err));
    },
    getFishStatisList(data) {
      this.apiGetFishStatisList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.obj.allitems = JSON.parse(json.Data);
            // this.obj.unitoptions = [
            //   ...new Set(this.obj.allitems.map((x) => x.SIF_UNIT)),
            // ];
            let list1 = [...new Set(this.obj.allitems.map((x) => x.SIF_UNIT))];
            list1.forEach((x) => {
              let object = {
                value: x,
                text: x == "1 公頃" ? "公頃" : "立方公尺",
              };
              this.obj.unitoptions.push(object);
            });
            this.obj.unit = this.obj.allitems[0].SIF_UNIT;
          }
        })
        .catch((err) => console.warn(err));
    },
    chartinit() {
      this.obj.chart.series = [];
      this.obj.chart.options.labels = [];
      this.obj.chart.options.yaxis = [];
      this.dataLabels=true;
    },
    createchart() {
      this.chartinit();
      let serieslist = [];
      let sinobj = {
        name: "單養",
        type: "line",
        data: this.obj.list.sinlist,
      };
      let mixobj = {
        name: "混養",
        type: "line",
        data: this.obj.list.mixlist,
      };
      // let resobj = {
      //   name: "休養",
      //   type: "line",
      //   data: this.obj.list.reslist,
      // };
      serieslist.push(sinobj);
      serieslist.push(mixobj);
      // serieslist.push(resobj);
      this.obj.chart.options.yaxis = [];
      this.obj.chart.options.yaxis.push({
        title: {
          text: "面積單位(每" + this.obj.unit + ")",
        },
      });
      this.obj.chart.series = serieslist;
      this.obj.chart.options.labels = this.obj.list.timelist;
      this.obj.chart.ifloading = false;
      if(this.dataLabels) this.obj.chart.options.dataLabels.enabled =true;
      else this.obj.chart.options.dataLabels.enabled =false;

      this.$nextTick(() => {
        this.$refs.chart1ref.updateSeries(this.obj.chart.series);
        this.$refs.chart1ref.updateOptions(this.obj.chart.options);
        this.$forceUpdate();
      });
    },
    parseChartData() {
      this.obj.list.timelist = [];
      this.obj.list.mixlist = [];
      this.obj.list.sinlist = [];
      this.obj.list.reslist = [];
      this.obj.table.items = this.obj.allitems.filter(
        (x) => x.SIF_UNIT == this.obj.unit
      );
      this.obj.table.totalRows = this.obj.table.items.length;
      this.obj.table.items.forEach((x) => {
        let subdate =
          parseInt(x.SIF_DATE.substring(0, 3)) +
          1911 +
          "/" +
          x.SIF_DATE.substring(3, 5);
        this.obj.list.timelist.push(subdate);
        this.obj.list.mixlist.push(x.SIF_MIX);
        this.obj.list.sinlist.push(x.SIF_SIN);
        this.obj.list.reslist.push(x.SIF_RES);
      });
      this.obj.table.isBusy = false;
      this.createchart();
    },
    handleResize() {
      this.obj.window.width = window.innerWidth;
    },
  },
  watch: {
    "obj.value"(val) {
      if (val != null && val != {}) {
        this.obj.chart.ifshow = true;
        this.obj.chart.ifloading = true;
        this.obj.table.isBusy = true;
        this.obj.list.timelist = [];
        this.obj.list.mixlist = [];
        this.obj.list.sinlist = [];
        this.obj.list.reslist = [];
        this.obj.unit = null;
        this.obj.unitoptions = [];
        this.FunctionToken(this.getFishStatisList, { SIF_SPEC: val.code });
      }
    },
    "obj.unit"(val) {
      if (val != null) this.parseChartData();
    },
    "dataLabels"(val){
            if(val){
                this.$refs.chart1ref.updateOptions({
                    dataLabels:{
                        enabled:true
                    }
                })
            }
            else{
                this.$refs.chart1ref.updateOptions({
                    dataLabels:{
                        enabled:false
                    }
                })
            }
            //console.log(this.chartOptions.dataLabels)
    }
  },
};
</script>
